export default "3d274967d56f636f.svg"